import React, { useEffect, useState } from "react";
import goldMedal from "../../../assets/goldMedal.svg";
import silverMedal from "../../../assets/silverMedal.svg";
import bronzeMedal from "../../../assets/bronzeMedal.svg";
// import usdt from "../../../assets/usdt.svg";
import tooltip from "../../../assets/tooltip.svg";
import getFormattedNumber from "../../../hooks/getFormattedNumber";
import OutsideClickHandler from "react-outside-click-handler";
import abbreviateNumber from "../../../hooks/abbreviateNumber";
import xMark from "../../../assets/xMark.svg";
import "../../Leaderboard/leaderboard.css"
import { NavLink } from "react-router-dom";
import rightArrow from '../assets/rightArrow.svg'

const AirdropView = ({
  username,
  leaderboard,
  weeklyLeaderboard,
  totalPoints,
  weeklyPoints,
  hasTgTask,
}) => {
  const [globalLeaderboard, setGlobalLeaderboard] = useState([]);
  const [globalUser, setGlobalUser] = useState({});
  const [tooltipInfo, setTooltipInfo] = useState(false);
  const [warnPopup, setWarnPopup] = useState(false);

  const updateUserScoreAndSort = (array, username, totalPoints) => {
    // Check if the user exists in the array
    const userExists = array.some((user) => user.username === username);

    // If user exists, update the score and sort the array
    if (userExists) {
      const updatedArray = array.map((user) =>
        user.username === username
          ? { ...user, totalPoints: totalPoints }
          : user
      );
      const sortedArray = updatedArray
        .sort((a, b) => b.totalPoints - a.totalPoints)
        .map((user, index) => ({ ...user, rank: index + 1 }));

      // Find the updated user
      const updatedUser = sortedArray.find(
        (user) => user.username === username
      );

      // Return both the sorted array and the updated user
      return { sortedArray, updatedUser };
    }

    return { sortedArray: array, updatedUser: { ...leaderboard.player } };
  };

  useEffect(() => {
    const { sortedArray, updatedUser } = updateUserScoreAndSort(
      leaderboard.users,
      username,
      totalPoints
    );

    setGlobalLeaderboard(sortedArray);
    setGlobalUser(updatedUser);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leaderboard, totalPoints, username, weeklyLeaderboard, weeklyPoints]);

  useEffect(() => {
    const hasVisited = sessionStorage.getItem("leaderboardPopup");
    if (!hasVisited && !hasTgTask) {
      // Show the welcome screen if it's the user's first visit in this session
      setWarnPopup(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="container-fluid leaderboard-wrapper pt-4 pb-3">
        <div className="d-flex flex-column gap-2">
          <div className="d-flex align-items-center justify-content-between w-100">
          <div className="d-flex align-items-center gap-2">
         <NavLink to={"/leaderboard"} className="rank-back-button  d-flex justify-content-center align-items-center">
        <img src={rightArrow} style={{transform: "rotate(180deg)"}} width={15} height={15} alt="" />
      </NavLink>
            <h6 className="leaderboard-main-title mb-0">Future Airdrop</h6>
         </div>
            <div className="position-relative d-flex align-items-center justify-content-center">
              <img
                src={tooltip}
                width={20}
                height={20}
                style={{ cursor: "pointer" }}
                alt=""
                onClick={() => setTooltipInfo(true)}
              />
              <OutsideClickHandler onOutsideClick={() => setTooltipInfo(false)}>
                <div
                  className={`leaderboard-tooltip-content-wrapper ${
                    tooltipInfo && "leaderboard-tooltip-active"
                  }`}
                >
                  <span>
                    - Weekly Prize Pool: 2,000 USDT distributed among the top 25
                    users each week.
                    {/* - Distribution Chain: BNB Chain, ensuring easy access to
                  rewards. */}
                    <br />- Weekly leaderboard: Rewards will be distributed
                    within 2 to 5 days after the leaderboard resets
                    <br />- Future Airdrop Eligibility: Coins earned will count
                    towards eligibility for future airdrops from our partners,
                    offering additional rewards for participation.
                  </span>
                  <br />
                  <span style={{ color: "#FF8168" }}>
                    Any users detected by our system for abuse will be
                    restricted, and their rewards will not be distributed.
                  </span>
                  <br />
                  <span style={{ color: "#FF8168" }}>
                    In order to be eligible for any weekly & future airdrops you
                    must be a member of the WoD Telegram Channel
                  </span>
                </div>
              </OutsideClickHandler>
            </div>
          </div>
          <div
            className={`user-leaderboard-rank w-100 d-flex align-items-center justify-content-between p-3`}
          >
            <div className="d-flex align-items-center gap-2">
              <div
                className={`name-holder d-flex align-items-center justify-content-center`}
              >
                <span className="name-initial">{username.slice(0, 1)}</span>
              </div>
              <div className="d-flex flex-column">
                <h6 className="user-name mb-0">{username}</h6>
                <span className="user-score-amount">
                  {getFormattedNumber(totalPoints, 0)} Coins
                </span>
              </div>
            </div>
            {globalUser?.rank === 1 ? (
              <img src={goldMedal} alt="gold" />
            ) : globalUser?.rank === 2 ? (
              <img src={silverMedal} alt="silver" />
            ) : globalUser?.rank === 3 ? (
              <img src={bronzeMedal} alt="bronze" />
            ) : (
              <span className="user-rank">#{globalUser?.rank}</span>
            )}
          </div>
          <div className="d-flex mt-3 align-items-bottom justify-content-between mb-3">
            <h6 className="mb-0 wod-total-holders">
              {getFormattedNumber(leaderboard.userCount, 0)} Participants
            </h6>
            <span className="top-100">(Top 100)</span>
          </div>
        </div>
        <div className="players-leaderboard d-flex flex-column">
          {globalLeaderboard.map((item, index) => (
            <div
              key={index}
              className="leaderboard-item d-flex align-items-center justify-content-between px-3 py-2"
            >
              <div className="d-flex align-items-center gap-2">
                <div className="name-holder d-flex align-items-center justify-content-center">
                  <span className="name-initial">
                    {item.username.slice(0, 1)}
                  </span>
                </div>
                <div className="d-flex flex-column">
                  <h6 className="player-name mb-0">
                    {item.username.length > 12
                      ? item.username.slice(0, 10) + "..."
                      : item.username}
                  </h6>
                </div>
              </div>
              <div className="d-flex align-items-center gap-2">
                <span className="player-score-amount">
                  {abbreviateNumber(item.totalPoints)} Coins
                </span>
                {index + 1 === 1 ? (
                  <img src={goldMedal} alt="" />
                ) : index + 1 === 2 ? (
                  <img src={silverMedal} alt="" />
                ) : index + 1 === 3 ? (
                  <img src={bronzeMedal} alt="" />
                ) : (
                  <span className="player-rank">#{index + 1}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <OutsideClickHandler
        onOutsideClick={() => {
          setWarnPopup(false);
          sessionStorage.setItem("leaderboardPopup", "true");
        }}
      >
        <div
          className={`connect-popup d-flex gap-2 align-items-start ${
            warnPopup && "connect-popup-active"
          } p-3`}
        >
          <span style={{ color: "#FF8168" }}>
            In order to be eligible for any weekly & future airdrops you must be
            a member of the WoD Telegram Channel!
          </span>
          <img
            src={xMark}
            alt=""
            style={{ cursor: "pointer" }}
            onClick={() => {
              setWarnPopup(false);
              sessionStorage.setItem("leaderboardPopup", "true");
            }}
          />
        </div>
      </OutsideClickHandler>
    </>
  );
};

export default AirdropView;
